import { useEffect } from 'react';
import withRouter from '@utils/wrappers/WithRouter';
import KpiMetrics from './KpiMetrics';
import { useAppDispatch } from '@redux/store';
import { IAppProps, IRouterProps } from '@interfaces/App.interface';
import { getKPI } from '@services/ApiService';
import { useRouterContext } from '@utils/context/RouterContext';

interface IKpiDefinitionExecutionResultsProps extends IAppProps, IRouterProps {}

const KpiDefinitionExecutionResults = (props: IKpiDefinitionExecutionResultsProps) => {
  const {
    transferPropsRoute: { params },
  } = useRouterContext();
  const kpiId = params.kpiId;
  const executionId = params.executionId;
  const dispatch = useAppDispatch();

  useEffect(() => {
    getKPI(dispatch, kpiId);
  }, []);

  return <KpiMetrics {...props} kpiId={kpiId} executionId={executionId} />;
};

export default KpiDefinitionExecutionResults;
